import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-schedule-not-registered',
  templateUrl: './schedule-not-registered.component.html',
  styleUrls: ['./schedule-not-registered.component.scss']
})
export class ScheduleNotRegisteredComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) message!: string;
  @Input() linksList: any[] = [];
  @Input() linksTitle!: string;
  @Input() image: string = "assets/imgs/schedule-not-registered.svg";
}
